import React, { useEffect } from 'react';
import classnames from 'classnames';

import { useRWD } from 'hooks';
import { useGetHomeArticlesGroup, useGetCmsSectionArticle } from 'api';

import styles from 'theme/pages/Home/components/KnowledgeBase/KnowledgeBase.module.scss';

export const KnowledgeBase = () => {
  const { isMobile } = useRWD();

  // pobranie listy artykułów z grupy KNOWLEDGE_BASE
  const { data: homeHomeArticlesGroupData } = useGetHomeArticlesGroup('KNOWLEDGE_BASE');

  // pobranie przycisku z CMS
  const { data: buttonArticleData, refetch: refetchButtonData } = useGetCmsSectionArticle(
    'HOMEPAGE_KNOWLEDGE_BASE_BUTTON',
    'HOMEPAGE_KNOWLEDGE_BASE_BUTTON',
    {
      enabled: false
    }
  );

  useEffect(() => {
    refetchButtonData();
  }, [refetchButtonData]);

  if (!homeHomeArticlesGroupData?.articles || homeHomeArticlesGroupData.articles.length === 0) {
    return null;
  }

  // Pobranie HTML przycisku z CMS
  const getButtonHtml = () => {
    if (!buttonArticleData?.article_fields) return null;
    const htmlField = buttonArticleData.article_fields.find(
      (field) => field.type === 'HTMLBLOCK'
    );
    return htmlField?.blob_value || htmlField?.value || null;
  };

  const buttonHtml = getButtonHtml();

  return (
    <div
      className={classnames(
        styles.componentWrapper,
        'StylePath-Pages-Home-components-KnowledgeBase'
      )}>
      <section className={styles.knowledgeBase}>
        <h2 className={styles.title}>{homeHomeArticlesGroupData?.title}</h2>
        <div className={styles.cardGrid}>
          {homeHomeArticlesGroupData.articles.map((article) => (
            <a
              key={article.id}
              href={article.url_link}
              className={styles.card}
              style={{
                backgroundImage: article.background_picture
                  ? `linear-gradient(177.08deg, rgba(0, 0, 28, 0) 8.22%, rgba(0, 0, 28, 0.485577) 40.39%, rgba(0, 0, 28, 0.8) 57.73%, #00001C 80.26%), url(${article.background_picture})`
                  : undefined
              }}>
              <span className={styles.cardLinkText}>{article.title}</span>
              <span className={styles.cardArrow}>→</span>
            </a>
          ))}
        </div>
        {buttonHtml && (
          <div
            className={styles.buttonWrapper}
            dangerouslySetInnerHTML={{ __html: buttonHtml }}
          />
        )}
      </section>
    </div>
  );
};

export default KnowledgeBase;

